module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider"
  }, [_c('ul', {
    staticClass: "slider__item view",
    style: ({
      width: ((_vm.items.length * 100) + "%"),
      marginLeft: ("-" + (_vm.curr * 100) + "%")
    })
  }, _vm._l((_vm.items), function(info, index) {
    return _c('li', {
      key: index,
      staticClass: "view__item",
      class: {
        'view__item_height': index !== _vm.curr
      },
      style: ({
        width: (((100 / _vm.items.length)) + "%")
      })
    }, [_vm._t("default", null, {
      "data": {
        info: info,
        index: index
      }
    })], 2)
  }), 0), _c('div', {
    staticClass: "slider__navi"
  }, [_c('div', {
    staticClass: "slider__arrow slider__arrow_prev",
    class: {
      'slider__arrow_disable': _vm.curr === 0
    },
    on: {
      "click": _vm.prevHendler
    }
  }), _c('ul', {
    staticClass: "slider__item navi"
  }, _vm._l((_vm.items), function(info, index) {
    return _c('li', {
      key: index,
      staticClass: "navi__item",
      class: {
        'navi__item_active': index === _vm.curr
      },
      on: {
        "click": function($event) {
          return _vm.naviHendler(index)
        }
      }
    })
  }), 0), _c('div', {
    staticClass: "slider__arrow slider__arrow_next",
    class: {
      'slider__arrow_disable': _vm.curr === _vm.items.length - 1
    },
    on: {
      "click": _vm.nextHendler
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5804718e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/slider/Slider.vue
// module id = 5a1ccd77aff411bb84bb
// module chunks = 89